/** Адрес MCP-коннектора Academy. Публичный; при необходимости переопределяется
 *  `VITE_MCP_URL` (например, для другого стенда). */
export const MCP_URL: string = import.meta.env.VITE_MCP_URL ?? 'https://mcp.academy.crypton.xyz/mcp'

export type ClientId = 'claude' | 'code' | 'chatgpt' | 'antigravity' | 'hermes'

export interface GuideStep {
  title: string
  /** Команда или значение, которое можно скопировать. */
  copy?: string
  /** Кнопка, открывающая нужную страницу сервиса в новой вкладке. */
  link?: { href: string; label: string }
}

export const CLIENTS: { id: ClientId; label: string }[] = [
  { id: 'chatgpt', label: 'ChatGPT' },
  { id: 'claude', label: 'Claude' },
  { id: 'code', label: 'Claude Code' },
  { id: 'antigravity', label: 'Antigravity' },
  { id: 'hermes', label: 'Hermes' },
]

/** Запись сервера для `mcp_config.json` Google Antigravity (ключ `serverUrl`, а не `url`). */
export const ANTIGRAVITY_CONFIG = `"oa-studio": { "serverUrl": "${MCP_URL}" }`

/** Hermes Agent (Nous Research): сервер добавляется командой CLI, вход — OAuth. */
export const HERMES_ADD_COMMAND = `hermes mcp add oa-studio --url ${MCP_URL} --auth oauth`

/** Подробный гайд по Hermes от сообщества — удалённый сервер, Telegram, ограничения. */
export const HERMES_GUIDE_URL = {
  ru: 'https://learn.open-academy.app/guides/ru/guide/kak-podkliuchit-oa-studio-k-hermes-agent',
  en: 'https://learn.open-academy.app/guides/en/guide/kak-podkliuchit-oa-studio-k-hermes-agent',
}

export interface PromptExample {
  topic: string
  text: string
}

export type { FaqItem } from '@/components/common/FaqList'
